/**
 * pass list of class names as arguments and get concatenated string
 */
export const joinClassNames = (...names: string[]): string => names.join(' ');
